import { LocalStorageKeyEnum } from 'lib/types/LocalStorageKeyEnum'
import iOS from './iOS'
import storage from 'local-storage-fallback'

export default function getLocalStorage(valueName: LocalStorageKeyEnum | string) {
  try {
    if (!iOS()) {
      return window.localStorage.getItem(valueName)
    } else {
      return storage.getItem(valueName)
    }
  } catch (err) {
    throw new Error((err as Error).message)
  }
}
